import gameConfig, { randomBetween } from '../config/gameConfig'
import { loadRating } from './rating'
import { generateOpponentDisplayName } from './nicknames'

const AVATAR_COLORS = [
  '#6366f1',
  '#ec4899',
  '#14b8a6',
  '#f59e0b',
  '#8b5cf6',
  '#ef4444',
  '#0ea5e9',
  '#84cc16',
  '#f97316',
  '#06b6d4',
]

function randomItem(list) {
  return list[Math.floor(Math.random() * list.length)]
}

function fillTemplate(str, vars) {
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : ''))
}

function getRegionPool() {
  const list = gameConfig.matchmaking.regions
  return list?.length ? list : ['华东', '华南', '华北']
}

export function pickDefaultMatchRegion() {
  return randomItem(getRegionPool())
}

export function createLocalProfile(name = '你', ratingScore, region) {
  const rating = ratingScore ?? loadRating()
  return {
    id: 'local',
    name,
    rating,
    region: region || pickDefaultMatchRegion(),
    avatarColor: '#10b981',
    isLocal: true,
  }
}

export function createFakeOpponent(localRating) {
  const spread = gameConfig.matchmaking.opponentRatingSpread
  const delta = randomBetween(-spread, spread)
  const name = generateOpponentDisplayName()
  return {
    id: `usr_${Math.random().toString(36).slice(2, 11)}`,
    name,
    rating: Math.max(100, (localRating ?? loadRating()) + delta),
    region: randomItem(getRegionPool()),
    avatarColor: randomItem(AVATAR_COLORS),
    isLocal: false,
    pingMs: randomBetween(
      gameConfig.matchmaking.pingMsMin,
      gameConfig.matchmaking.pingMsMax
    ),
  }
}

function serverLabelForRegion(region) {
  const names = gameConfig.matchmaking.serverNames
  const hit = names.find((n) => n.startsWith(region))
  if (hit) return hit
  return `${region}-${randomBetween(1, 9)}`
}

/** 模拟联机匹配：分阶段回调；selectedRegion 为大厅所选区服（展示用） */
export function runMatchmaking(onPhase, localRating, selectedRegion) {
  const opponent = createFakeOpponent(localRating)
  const region = selectedRegion || pickDefaultMatchRegion()
  const server = serverLabelForRegion(region)
  const ahead = randomBetween(
    gameConfig.matchmaking.queueAheadMin,
    gameConfig.matchmaking.queueAheadMax
  )
  const eta = randomBetween(
    gameConfig.matchmaking.etaSecondsMin,
    gameConfig.matchmaking.etaSecondsMax
  )

  const phases = gameConfig.matchmaking.phases.map((p) => ({
    ...p,
    ms: randomBetween(p.msMin, p.msMax),
    label: fillTemplate(p.label, { server, ahead, eta }),
  }))

  let i = 0
  return new Promise((resolve) => {
    const tick = () => {
      if (i >= phases.length) {
        resolve(opponent)
        return
      }
      const p = phases[i]
      onPhase({
        key: p.key,
        label: p.label,
        server,
        stepIndex: i,
        progress: Math.round(((i + 1) / phases.length) * 100),
        opponent: i >= 2 ? opponent : null,
        pingMs: gameConfig.matchmaking.showFakePing
          ? randomBetween(
              gameConfig.matchmaking.pingMsMin,
              gameConfig.matchmaking.pingMsMax
            )
          : null,
      })
      i += 1
      setTimeout(tick, p.ms)
    }
    tick()
  })
}

export function assignSides(localProfile, opponent) {
  const localIsBlack = Math.random() < 0.5
  return {
    black: localIsBlack ? localProfile : opponent,
    white: localIsBlack ? opponent : localProfile,
    localColor: localIsBlack ? 1 : 2,
  }
}

export function formatMatchRoomId() {
  return `RM-${Date.now().toString(36).toUpperCase().slice(-6)}`
}